export default "__VITE_ASSET__Dvk7Lswq__"